var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyAvatarProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 90,
    height: 90,
    rx: 45,
    stroke: "#A2A9C8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4893 16.6523C54.7318 16.6523 61.4078 23.3284 61.4078 31.5708C61.4078 39.8133 54.7318 46.4893 46.4893 46.4893C38.2468 46.4893 31.5708 39.8133 31.5708 31.5708C31.5708 23.3284 38.2468 16.6523 46.4893 16.6523ZM46.4893 76.3263C46.4893 76.3263 76.3263 76.3263 76.3263 68.867C76.3263 59.9159 61.7807 50.2189 46.4893 50.2189C31.1979 50.2189 16.6523 59.9159 16.6523 68.867C16.6523 76.3263 46.4893 76.3263 46.4893 76.3263Z",
    stroke: "#A2A9C8",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatarProfile);
export default __webpack_public_path__ + "static/media/empty-avatar-profile.68c390f61d65e7dab25f27b4d002f0c5.svg";
export { ForwardRef as ReactComponent };